module.exports = __webpack_public_path__ + "img/innerpages_banner1.18c36a99.jpg";